
$(".close_link").on('click', function(){
    window.open('about:blank','_self').close();
});

$(".map_print_btn").on('click', function(){
    window.print();
});

$(function(){
    var canvas = document.getElementById('map-canvas');
    var icon = canvas.getAttribute('target-icon');
    var lat = canvas.getAttribute('target-lat');
    var lng = canvas.getAttribute('target-lng');
    var latlng = new google.maps.LatLng(lat, lng);

    var mapOptions = {
        zoom: 18,
        center: latlng,
        gestureHandling: 'greedy',
        mapId:"DEMO_MAP_ID"
    };
    var map = new google.maps.Map(canvas, mapOptions);

    var markers = [];

    markers[0] = new google.maps.marker.AdvancedMarkerElement({
        map: map,
        position: latlng,
        // icon: icon,
    });
    markers[0].content.className = "animation-down";
});
